
    var riot = require('riot')
    riot.tag2('gb-sayt-products', '<gb-list items="{$sayt.products}"> <yield> <gb-product all-meta="{$item.allMeta}"> <gb-product-image thumbnail></gb-product-image> </gb-product> </yield> </gb-list>', 'gb-sayt-products.gb-stylish,[data-is="gb-sayt-products"].gb-stylish{ min-width: 300px; } gb-sayt-products.gb-stylish ul,[data-is="gb-sayt-products"].gb-stylish ul{ display: flex; flex-wrap: wrap; align-items: center; width: calc(86px * 4); align-content: flex-start; } gb-sayt-products.gb-stylish gb-product-image img,[data-is="gb-sayt-products"].gb-stylish gb-product-image img{ vertical-align: bottom; } gb-sayt-products.gb-stylish gb-product-image img:hover,[data-is="gb-sayt-products"].gb-stylish gb-product-image img:hover{ box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2); }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-products.tag.html